import type { Persona } from '../types/persona';

const BASE_URLS = {
  landlord: '/rental-manager',
  renter: '/renter-hub',
} as const;

/**
 * Returns the base URL for the given persona.
 *
 * @param persona The persona to return the base URL for (landlord or renter).
 * @returns The base URL for the given persona.
 */
export default (persona: Persona): string => BASE_URLS[persona];
